// eslint-disable-next-line
import datepicker from 'bootstrap-datepicker';

jQuery(document).ready(function() {
  let inputs = jQuery('.hero--homepage__form input.date, .quote-form-wrapper .gfield.date input');
  if (inputs.length) {
    inputs.each(function() {
      let input = jQuery(this);
      input.datepicker({
        format: 'dd/mm/yy',
        startDate: new Date(),
        weekStart: 1,
      });
    });
  }

  let dropdown = jQuery('.hero--homepage__form select');
  let returnDate = jQuery('.hero--homepage__form #return');
  if (dropdown.length && returnDate.length) {
    let label = returnDate.find('label');
    let input = returnDate.find('input');
    dropdown.on('change', function() {
      if (dropdown.val() === 'Return') {
        label.css('display', 'block');
        input.css('display', 'block');
      } else {
        label.css('display', 'none');
        input.css('display', 'none');
      }
    });
  }
});
